/**
 * Canonical occupation options. Mirrors the shape of CATEGORIES:
 * shared, typed, and the single source of truth for both the select
 * options and the Zod validator. Adding a future option is a one-line
 * edit here plus two locale keys.
 */
export const OCCUPATION_OPTIONS = [
  { value: "student", labelKey: "occupation.student" },
  { value: "employee", labelKey: "occupation.employee" },
  { value: "other", labelKey: "occupation.other" },
] as const;

export type Occupation = (typeof OCCUPATION_OPTIONS)[number]["value"];

export const OCCUPATION_VALUES = OCCUPATION_OPTIONS.map((o) => o.value) as [
  Occupation,
  ...Occupation[],
];

/** True when `v` is one of the canonical occupation values. */
export function isOccupation(v: unknown): v is Occupation {
  return typeof v === "string" && (OCCUPATION_VALUES as readonly string[]).includes(v);
}
